import { setShipments, setGreenChannels } from "../actions/shipment";
import { setUser } from "../actions/user";
import store from "../store/storeInstance";
import { get } from "../utils/barrels/lodash";
import { reloadUser } from "../utils/functions";
import promiseCache from "../utils/promiseCache";

import { axiosInstance, axiosFastApiInstance } from "./apiInstance";
import * as urls from "./urls.json";

export const getDeliveryPartners = () => (dispatch) =>
	axiosInstance
		.get(urls.getDeliveryPartnerList, {
			params: {
				all_records: true,
			},
		})
		.catch((err) => {
			if (err?.response?.status) {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getDPModeLists = () => (dispatch) =>
	axiosInstance
		.get(urls.getModeList)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getShipments = (pageNo, filterVals, page_size) => {
	const cacheKey = `getShipments_${pageNo}_${page_size}_${JSON.stringify(
		filterVals || {}
	)}`;
	return (dispatch) => {
		if (promiseCache.isInProgress(cacheKey)) {
			return promiseCache.getExistingPromise(cacheKey);
		}

		const promise = axiosInstance
			.get(urls.getShipmentList, {
				params: {
					page: pageNo || undefined,
					page_size: page_size || undefined,
					...filterVals,
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					dispatch(setShipments(response.data));
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
		return promiseCache.startCall(cacheKey, promise);
	};
};

export const getShipmentsFetch = (pageNo, filterVals, page_size) => {
	const cacheKey = `getShipmentsFetch_${pageNo}_${page_size}_${JSON.stringify(
		filterVals || {}
	)}`;
	return (dispatch) => {
		if (promiseCache.isInProgress(cacheKey)) {
			return promiseCache.getExistingPromise(cacheKey);
		}

		const promise = axiosInstance
			.get(urls.getShipmentFetchList, {
				params: {
					page: pageNo || undefined,
					page_size: page_size || undefined,
					...filterVals,
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					dispatch(setShipments(response.data));
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});

		return promiseCache.startCall(cacheKey, promise);
	};
};

export const getStuckShipments =
	(pageNo, filterVals, page_size) => (dispatch) =>
		axiosInstance
			.get(urls.getStuckShipmentList, {
				params: {
					page: pageNo || undefined,
					page_size: page_size || undefined,
					...filterVals,
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					dispatch(setShipments(response.data));
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});

export const getUpdatedShipments = (shipmentID) => (dispatch) =>
	axiosInstance
		.get(`/shipments/${shipmentID}`)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				dispatch(setShipments(response.data));
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getShipmentAmountCharged = (filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getShipmentAmountCharged, {
			params: {
				...filterVals,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				dispatch(setShipments(response.data));
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const addShipment = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.createShipment, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const editShipment = (obj, shipmentId) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`/shipments/${shipmentId}`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const deleteShipment = (id) => (dispatch) =>
	axiosInstance
		.delete(`/shipments/${id}/`)
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: true,
						showReAuthModal: true,
						requestType: "delete",
					})
				);
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 204) {
				return true;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getDeliveryPartnerWarehouses =
	(id, fetchAll, client_id, searchVal) => (dispatch) =>
		axiosInstance
			.get(urls.getWarehouseAssociationsList, {
				params: {
					delivery_partner: id || undefined,
					all_records: fetchAll || undefined,
					client: client_id || undefined,
					q: searchVal || undefined,
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
const geturl = (misfor) => {
	let url = urls.downloadMIS;
	if (misfor === "order") {
		url = urls.downloadOrderMis;
	}
	if (misfor === "weight") {
		url = urls.downloadWeightDiscrepancy;
	}
	if (misfor === "gm") {
		url = urls.downloadGrossMarginReport;
	}
	if (misfor === "ndr") {
		url = urls.downloadNDRMis;
	}
	return url;
};

export const misDownload = (queryParams, misfor = "shipment") => {
	const paramsWithEmails = {
		...queryParams,
		emails: store.getState().shipment.add_on_emails.toString(),
	};
	return (dispatch) =>
		axiosInstance
			.get(geturl(misfor), {
				params: paramsWithEmails,
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const stuckShipmentDownload = (queryParams) => {
	const paramsWithEmails = {
		...queryParams,
		emails: store.getState().shipment.add_on_emails.toString(),
	};
	return (dispatch) =>
		axiosInstance
			.get("/download_stuck_shipment", {
				params: paramsWithEmails,
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getShipmentTrackDetails = (id) => () =>
	axiosInstance
		.get(`/shipment/track/${id}`)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				// reloadUser()
				// dispatch(setUser({reAuth: false, showReAuthModal: false, requestType: 'get'}))
				// window.location.reload()
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const calculateShipment = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.getShipmentCharges, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getPickuptime = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.getDPPickupAvailability, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};
// Orders APIs

export const retryShipment = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.retryShipment, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getOrders = (pageNo, page_size, filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getOrderList, {
			params: {
				page: pageNo || undefined,
				page_size: page_size || undefined,
				...filterVals,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				dispatch(setShipments(response.data));
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getUpdatedOrders = (orderId) => (dispatch) =>
	axiosInstance
		.get(`/orders/${orderId}`)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				dispatch(setShipments(response.data));
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const createOrder = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.createOrder, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const editOrder = (obj, orderId) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`/orders/${orderId}/`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const orderShipmentAssociation = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.createShipmentOrderAssociation, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const editOrderAssociationShipment = (obj, shipmentId) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`/order_shipment_association/${shipmentId}/`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const editAppointmentShipment = (obj, shipmentId) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`/add_appointment/${shipmentId}/`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const bulkUploadOrders = (fileName, url = "uploads/files/") => {
	const reqObj = {
		file_path: url,
		file_name: fileName,
		emails: store.getState().shipment.add_on_emails.toString(),
	};
	const body = JSON.stringify(reqObj);
	return (dispatch) =>
		axiosInstance
			.post(urls.bulkCreateShipments, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const bulkUploadWarehouse = (fileName, url = "uploads/files/") => {
	const reqObj = {
		file_path: url,
		file_name: fileName,
		emails: store.getState().shipment.add_on_emails.toString(),
	};
	const body = JSON.stringify(reqObj);
	return (dispatch) =>
		axiosInstance
			.post(urls.bulkCreateWarehouse, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const mapPickupShipment = (pickupId, shipmentId) => {
	const reqObj = {
		pickup_id: pickupId,
		shipment_id: shipmentId,
	};
	const body = JSON.stringify(reqObj);
	return (dispatch) =>
		axiosInstance
			.put(urls.mapPickupToShipment, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const deleteOrder = (id) => (dispatch) =>
	axiosInstance
		.delete(`/orders/${id}`)
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: true,
						showReAuthModal: true,
						requestType: "delete",
					})
				);
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 204) {
				return true;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getShipmentCounts = (clientId, daterange = {}) => {
	const cacheKey = `getShipmentCounts_${clientId}_${JSON.stringify(daterange)}`;
	return (dispatch) => {
		if (promiseCache.isInProgress(cacheKey)) {
			return promiseCache.getExistingPromise(cacheKey);
		}

		const promise = axiosInstance
			.get(urls.getShipmentCounts, {
				params: {
					client_id: clientId,
					...daterange,
				},
			})
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
		return promiseCache.startCall(cacheKey, promise);
	};
};

export const toPayShipmentList = (pageNo, filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getToPayShipments, {
			params: {
				page: pageNo || undefined,
				...filterVals,
			},
		})
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const weightDiscrepancieList = (pageNo, filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getWeightDiscrepancies, {
			params: {
				page: pageNo || undefined,
				...filterVals,
			},
		})
		.catch((err) => {
			if (err.response.status === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const raiseDispute = (obj, id) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`${urls.getWeightDiscrepancies}${id}/`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const downloadRemittance = (queryParams) => {
	const add_on_emails = store.getState().shipment.add_on_emails.toString();
	return (dispatch) =>
		axiosInstance
			.get(urls.downloadRemittance, {
				params: {
					add_on_emails,
					...queryParams,
				},
			})
			.catch((err) => {
				if (err.response.status === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "get",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getNdrShipments = (pageNo, filterVals, page_size) => (dispatch) =>
	axiosInstance
		.get(urls.getNdrShipmentList, {
			params: {
				page: pageNo || undefined,
				page_size: page_size || undefined,
				...filterVals,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				dispatch(setShipments(response.data));
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const editNDRShipment = (obj, ndrShipmentId) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`${urls.getNdrShipmentList}${ndrShipmentId}/`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

// abd request api

export const getAbdRequest = (filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.getAbdRequestApi, {
			params: {
				...filterVals,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const postUploadAbdRequest = (
	fileName,
	typeOfEvent,
	url = "uploads/files/abd_uploader/"
) => {
	const reqObj = {
		file_name: fileName,
		file_path: url,
		type_of_event: typeOfEvent,
	};
	const body = JSON.stringify(reqObj);

	return (dispatch) =>
		axiosInstance
			.post(urls.UploadAbdRequest, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const postDownloadAbdRequest = (fieldQuery, reqBody) => {
	const body = JSON.stringify({ ...fieldQuery, ...reqBody });
	return (dispatch) =>
		axiosInstance
			.post(urls.postDownloadAbdRequest, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const postUploadNdrBulkAction = (fileName, url = "uploads/files/") => {
	const reqObj = {
		file_name: fileName,
		file_path: url,
		emails: store.getState().shipment.add_on_emails.toString(),
	};
	const body = JSON.stringify(reqObj);

	return (dispatch) =>
		axiosInstance
			.post(urls.uploadNdrBulkAction, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const putAbdRequestApi = (obj, order_id) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`${urls.putAbdRequestApi}${order_id}/`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const postPoMultipleUpload = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.postPoMultipleUpload, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getPricingPlanPopup = (clientId) => (dispatch) =>
	axiosInstance
		.get(urls.getPricingPlanPopup, {
			params: {
				client_id: clientId,
			},
		})
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getPricingPlan = () => (dispatch) =>
	axiosInstance
		.get(urls.getPricingPlan)

		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getPricingPLanSaving = (filterVals) => (dispatch) =>
	axiosInstance
		.get(urls.pricingPlanSaving, { params: { ...filterVals } })

		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const putUpdaetEwayBillApi = (obj, shipmentId) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.put(`/update_ewaybill_no/${shipmentId}/`, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getChannelOrdersApi = (obj) => (dispatch) =>
	axiosFastApiInstance
		.get(urls.getChannelOrders, { params: obj })

		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getChannelOrdersByIdApi = (orderId) => (dispatch) =>
	axiosFastApiInstance
		.get(`${urls.getChannelOrdersById}/${orderId}`)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const activateChannelApi = (obj) => (dispatch) =>
	axiosFastApiInstance
		.get(urls.activateChannel, { params: obj })

		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const postSaveChannelShopDetails = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosFastApiInstance
			.post(urls.saveChannelShopDetails, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const postChannelLocationSyncerApi = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosFastApiInstance
			.post(urls.channelLocationSync, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const getChannelDetailsApi = (obj) => (dispatch) =>
	axiosFastApiInstance
		.get(urls.getChannelDetails, { params: obj })
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const patchChannelRolesApi = (id, obj) => (dispatch) =>
	axiosFastApiInstance
		.patch(`${urls.updateChannelRoles}/${id}/roles`, obj)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
				);
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const generateShipmentLabel = (waybillNo) => (dispatch) =>
	axiosInstance
		.get(`${urls.generateLabel}${waybillNo}/`)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getGreenChannels = () => (dispatch) =>
	axiosInstance
		.get(urls.getGreenChannels)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				dispatch(setGreenChannels(response.data));
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getCodBannerPopupDetailApi = (obj) => (dispatch) =>
	axiosInstance
		.get(urls.ecodBannerPopup, { params: obj })
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getEcodPlanDeactivateApi = (obj) => (dispatch) =>
	axiosInstance
		.post(urls.ecodPlanDeactivate, { params: obj })
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getCRFFileDownloadApi = (crfId) => (dispatch) =>
	axiosInstance
		.get(`${urls.crfFileDownloadUrl}${crfId}/`)
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.message);
				throw err;
			}
		});

export const getExternalCodRemittanceApi = (obj) => (dispatch) =>
	axiosInstance
		.get(urls.externalCodRemittance, { params: obj })
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getFutureCodRemittanceApi = (params) => (dispatch) =>
	axiosInstance
		.get(urls.futureCodRemittance, { params })
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const getClientBusinessBoxPopupDetailsApi = (obj) => (dispatch) =>
	axiosInstance
		.get(urls.getClientBusinessBoxPopupDetails, { params: obj })
		.catch((err) => {
			const errResponse = get(err, "response.status", false);
			if (errResponse === 401) {
				reloadUser();
				dispatch(
					setUser({
						reAuth: false,
						showReAuthModal: false,
						requestType: "get",
					})
				);
				window.location.reload();
			}
			throw err;
		})
		.then((response) => {
			if (response.status === 201 || response.status === 200) {
				return response.data;
			} else {
				const err = new Error(response.data.msg);
				throw err;
			}
		});

export const postCodPlanApi = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.postCodPlan, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const postPOUploaderApi = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.podDocumentUpload, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const postBusinessProductUpdateApi = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.postBusinessProductUpdate, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({ reAuth: true, showReAuthModal: true, requestType: "put" })
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const postOrderCancelationApi = (obj) => {
	const body = JSON.stringify(obj);
	return (dispatch) =>
		axiosInstance
			.post(urls.orderCancellation, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const cancelShipment = (
	shipmentId,
	reason,
	cancelledStatus = "pending"
) => {
	const body = JSON.stringify({
		shipment_id: shipmentId,
		cancelled_status: cancelledStatus,
		reason,
	});
	return (dispatch) =>
		axiosInstance
			.post(urls.shipmentCancellation, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(
						response.data.msg ||
							response.data.message ||
							"Failed to cancel shipment"
					);
					throw err;
				}
			});
};

export const postRemittanceUploadApi = (fileName, url = "uploads/files/") => {
	const reqObj = {
		file_name: fileName,
		file_path: url,
	};
	const body = JSON.stringify(reqObj);

	return (dispatch) =>
		axiosInstance
			.post(urls.uploadRemittance, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: true,
							showReAuthModal: true,
							requestType: "post",
						})
					);
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 201 || response.status === 200) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const updateSellerContact = (obj) => {
	const body = JSON.stringify({
		order_id: obj.orderId,
		delivery_partner_id: obj.deliveryPartnerId,
		seller_contact_person_name: obj.name,
		seller_contact_no: obj.phone,
	});
	return (dispatch) =>
		axiosInstance
			.patch(urls.updateSellerContact, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "patch",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200 || response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.msg);
					throw err;
				}
			});
};

export const shipmentReschedule = (obj) => {
	const body = JSON.stringify({
		shipment_id: obj.shipmentId,
		new_scheduled_date: obj.newScheduledDate,
		remarks: obj.rescheduleReason,
	});
	return (dispatch) =>
		axiosInstance
			.post(urls.shipmentReschedule, body)
			.catch((err) => {
				const errResponse = get(err, "response.status", false);
				if (errResponse === 401) {
					reloadUser();
					dispatch(
						setUser({
							reAuth: false,
							showReAuthModal: false,
							requestType: "post",
						})
					);
					window.location.reload();
				}
				throw err;
			})
			.then((response) => {
				if (response.status === 200 || response.status === 201) {
					return response.data;
				} else {
					const err = new Error(response.data.message);
					throw err;
				}
			});
};
